export function loadTranslations(translationFiles) {
    return translationFiles;
}
export function validateTranslations(translations, requiredKeys) {
    const missingKeys = {};
    for (const [language, dictionary] of Object.entries(translations)) {
        if (dictionary) {
            const missing = requiredKeys.filter(key => !(key in dictionary));
            if (missing.length > 0) {
                missingKeys[language] = missing;
            }
        }
    }
    return missingKeys;
}
